import { Login } from 'api';

export const loginFetcher = credentails => {
  return Login.post(credentails);
};
